import React, { useContext, useEffect, useState } from 'react';
import { FarzaaContext } from '../../context/FarzaaContext';
import { Link } from 'react-router-dom';
import userApi from '../../api/userApi';

const ProductContainer = () => {
    const { isListView, addToCart } = useContext(FarzaaContext);
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchProducts = async () => {
            try {
                const productData = await userApi.getProduct();
                setProducts(productData);
            } catch (error) {
                console.error('Error fetching products:', error);
            } finally {
                setLoading(false);
            }
        };
        fetchProducts();
    }, []);


    return (
        <div className={`fz-inner-products-container ${isListView ? 'list-view-on' : ''}`}>
            <div className="row">
                {loading ? (
                    <div className="loading-area">
                        <h3>Loading products...</h3>
                    </div>
                ) : products.length === 0 ? (
                    <div className="no-product-area">
                        <h3 className="no-product-text">No Products Available</h3>
                        <p className="no-product-desc">
                            We're sorry. We cannot find any matches for your search term.
                        </p>
                    </div>
                ) : (
                    products.map((product) =>
                        product.productDetails.map((detail) => (
                            <div className="col-xl-3 col-md-4 col-6 col-xxs-12" key={detail.productDetailId}>
                                <div className="fz-1-single-product">
                                    <div className="fz-single-product__img">
                                        <img src={detail.imageLink} alt={detail.name} />
                                        <div className="fz-single-product__actions">
                                            <button
                                                className="fz-add-to-cart-btn"
                                                onClick={() => addToCart(detail.productDetailId)}
                                            >
                                                <span className="btn-txt">Add to Cart</span>
                                                <span className="btn-icon">
                                                    <i className="fa-light fa-cart-shopping"></i>
                                                </span>
                                            </button>
                                        </div>
                                    </div>
                                    <div className="fz-single-product__txt">
                                        <span className="fz-single-product__category list-view-text">
                                            {product.name}
                                        </span>
                                        <Link
                                            to={{
                                                pathname: `/shopDetails/${detail.url}`, 
                                            }}
                                            className="fz-single-product__title"
                                        >
                                            {detail.name}
                                        </Link>
                                        <div className="fz-single-product__price-rating">
                                            <div className="rating">
                                                <i className="fa-solid fa-star"></i>
                                                <i className="fa-solid fa-star"></i>
                                                <i className="fa-solid fa-star"></i>
                                                <i className="fa-solid fa-star"></i>
                                                <i className="fa-solid fa-star"></i>
                                            </div>

                                            <p className="fz-single-product__price">
                                                <span className="current-price">{detail.price.toLocaleString('en-US')} vnđ</span>
                                            </p>
                                            <p className="fz-single-product__price">
                                                <span className="current-price">Kho: {detail.stock}</span>
                                            </p>
                                            <p className="fz-single-product__price">
                                                <span className="current-price">Đã bán: {product.salesVolume}</span>
                                            </p>
                                            <p className="fz-single-product__price">
                                                <span className="current-price">Mô tả: {product.note}</span>
                                            </p>

                                        </div>
                                        <p className="fz-single-product__desc list-view-text">
                                            {detail.description}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        ))
                    )
                )}
            </div>
        </div>
    );
};

export default ProductContainer;
